import { render, staticRenderFns } from "./AppMapButton.vue?vue&type=template&id=3516a5d2&"
import script from "./AppMapButton.vue?vue&type=script&lang=ts&"
export * from "./AppMapButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppMapButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports